import React from 'react';
import { Toolbar, Button } from '@mui/material';
import { SaveButton } from 'react-admin';
import CancelArrow from '@/assets/icons/cancel-arrow-icon.svg?react';

const TagCategoryToolbar = ({ onCancel, cancelLabel, saveLabel, saveIcon = null, endIcon = null }) => (
    <Toolbar className='modal-toolbar' sx={{ '& .MuiButtonBase-root': { borderRadius: '12px' } }}>
        <Button onClick={onCancel} color='secondary' variant='contained' startIcon={<CancelArrow />} sx={{ fontWeight: 500 }}>
            {cancelLabel}
        </Button>
        <SaveButton
            label={saveLabel}
            icon={saveIcon}
            endIcon={endIcon}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontWeight: 500,
                padding: '10px 20px',
                '& svg': {
                    marginRight: '8px',
                },
                '& .MuiButton-endIcon': {
                    marginRight: '-12px',
                },
            }}
        />
    </Toolbar>
);

export default TagCategoryToolbar;
